module.exports = __webpack_public_path__ + "static/media/18ECA20.8a0a70a6.jpg";